import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabase/client'

const ResetPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [isSent, setIsSent] = useState(false)
  const navigate = useNavigate()

  const handleReset = async (e) => {
    e.preventDefault()
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      // Supabase automatically generates and sends a reset token in the email link
      //   redirectTo: window.location.origin + '/set-new-password',
    })
    if (error) {
      console.error('Reset password error:', error.message)
      setError(error.message)
    } else {
      console.log(
        'Reset email sent successfully. Redirect URL used:',
        window.location.origin + '/set-new-password',
      )
      setIsSent(true)
      setMessage('Проверьте вашу почту для ссылки на сброс пароля.')
    }
  }

  return (
    <div className="container">
      {!isSent ? (
        <>
          <h2>Восстановление пароля</h2>
          <form onSubmit={handleReset}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Введите ваш email"
              />
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn">
              Отправить ссылку на сброс
            </button>
          </form>
        </>
      ) : (
        <>
          <div>{message}</div>
          <button onClick={() => navigate('/login')} className="btn">
            Назад к входу
          </button>
        </>
      )}
    </div>
  )
}

export default ResetPasswordPage
